import _get from 'lodash/get';
import _filter from 'lodash/filter';
import _find from 'lodash/find';
import * as actions from '../actionTypes';
import {
  CROSS_SELL_RECOMMENDATIONS_REQUEST,
  CROSS_SELL_RECOMMENDATIONS_SUCCESS,
  CROSS_SELL_RECOMMENDATIONS_FAILURE
} from '../actionTypes';
import { showLoader, hideLoader } from '../../actions/shared/loader';
import { showError, setErrorObject, showErrorMessageInfo } from '../../actions/shared/HTTPError';
import endPoints from '../../modules/ajio-util/endpoints';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser
} from '../../modules/ajio-fetch/utils';
import commify from '../../modules/ajio-util/commify.js';
import { errorProcessor as cartErrorProcessor } from '../../modules/ajio-fetch/errorProcessor';

import { setCartItem, setGiftItem } from './cartItem';
import { setCartData } from './cartData';
import isNode from '../../modules/ajio-util/isNode';
import { getVouchers } from './voucher';
import { showWishlistDialog } from '../../wishlist/actions/wishlist';

import { createAnonymousToken, setToken } from '../../actions/authUser';

import {
  setCart,
  cartItemData,
  getCartSuccess,
  getCartFail,
  updateToCartError,
  setVouchers,
  removeVoucher,
  removeCard,
  setSizeDetails,
  getProductSize,
  setCartInventoryCheck,
  setInternalWallet,
  giftItemData,
  resetCartErrors
} from './cartActionCreator';

import { createCart } from '../../actions/addProductToCart';

import { readCookie } from '../../utils/Cookie';
import { readCohortValueCookie } from '../../components/common/Cookie';
import { getAmplitudeVariantPayload } from '../../utils/amplitudeCommon';
import { setCheckedAddress } from '../../myaccount/actions/addressBook';
import properties from '../../modules/ajio-util/properties';
import getEncryptedData from '../../utils/encryption';
import { setGSTCartDetails } from './gst';

export function getUserName(request = {}) {
  let userName = '';

  if (Object.keys(request).length) {
    const { cookies = {} } = request;
    userName = cookies.U;
  } else if (document) {
    userName = readCookie('U');
  }
  return userName;
}

/**
 * This file will need refactoring for the (voucher , gift wrap) actions in
 * separate file. And for (endpoints) which has not be hardcoded in actions has
 * to be configuration based.
 *
 * Identify the common code (in cart, voucher, giftwrap) to move into separate function like setting cart data
 *
 */

/**
 * Method to set cart particular key like coupon code data. If we modify the coupon code after get cart
 */

export function createcart(requestObj = {}) {
  const { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  return dispatch => {
    const { U: user = '', A: accessToken = '' } = request.cookies;

    const { headers: { host = '' } = {} } = request;

    return new Promise((resolve, reject) => {
      createCart({ user, accessToken, apiEndPoint: `http://${host}/api/cart/create` })
        .then(cartResponse => {
          if (user === 'anonymous') {
            request.cookies.AGUID = cartResponse.guid;
          } else {
            request.cookies.GUID = cartResponse.guid;
          }
          resolve(cartResponse);
        })
        .catch(error => reject(error));
    });
  };
}

export function getCart(requestObj = {}, callback, isRecursivelyCalling = false) {
  let {
    isRequestOrginIsBrowser = false,
    request = {},
    apiEndPoint: endPoint = '',
    isShipping,
    oldWallet = [],
    newWallet = [],
    selectedWallet = {},
    updateInternalWallet = false
  } = requestObj;
  const customerType = _get(requestObj, 'request.cookies.customerType', 'All');
  const client_type = _get(requestObj, 'request.device.client_type', 'MSITE');
  return dispatch => {
    const { pathname = '' } = request;
    let apiEndPoint;
    let guestUserGuid;
    let user;
    let loggedInUserGuid;
    let existingCartId;
    /**
     * Show loader if the call is triggered from client-side
     */

    let body = {};
    let headers = { 'content-type': 'application/json' };

    if (isRequestOrginIsBrowser) {
      dispatch(resetCartErrors());
      dispatch(showLoader('cart-loader'));
      apiEndPoint = `/api/cart/getcart`;
      body = { client_type, _fpuuid: readCookie('_fpuuid') };
    } else {
      ({
        AGUID: guestUserGuid = '',
        U: user = '',
        GUID: loggedInUserGuid = '',
        C: existingCartId = ''
      } = request.cookies);
      const { headers: { host = '' } = {} } = request;
      const { _fpuuid } = request.cookies;
      /**
       *  API call based on information.
       *  If Registered user lands to cart page & we've "loggedInUserGuid",
       *  then merge directly. If not available,then we need to get cart & then
       *  take a call whether to merge it or not.
       *
       *  For Anonymous user we'll always call get-cart.
       */
      if (guestUserGuid && user !== 'anonymous') {
        if (loggedInUserGuid) {
          apiEndPoint = `http://${host}/api/cart/merge`;
          body = {
            oldCartId: loggedInUserGuid,
            A: request.cookies.A,
            U: request.cookies.U,
            toMergeCartGuid: guestUserGuid,
            client_type,
            customerType,
            isShipping
          };
        } else {
          apiEndPoint = `http://${host}/api/cart/getcart`;
          body = {
            A: request.cookies.A,
            U: request.cookies.U,
            client_type,
            customerType,
            isShipping,
            _fpuuid
          };
        }
      } else {
        apiEndPoint = `http://${host}/api/cart/getcart`;
        body = {
          A: request.cookies.A,
          U: request.cookies.U,
          C: request.cookies.C,
          client_type,
          customerType,
          isShipping,
          _fpuuid
        };
      }

      if (endPoint.length > 0) {
        apiEndPoint = endPoint;
      }

      headers['x-device'] = request.device.type === 'phone' ? 'phone' : 'pc';
    }
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: headers,
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          refreshChecksum = '',
          loyaltyPointsInfo = '',
          otpValidationRequired = true,
          backendInternalWalletFlag = false
        } = response;
        let { internalWallets = [] } = response;
        if (updateInternalWallet) {
          oldWallet = oldWallet.length ? oldWallet : internalWallets;
          internalWallets = mergeInteranlWallet(oldWallet, newWallet, selectedWallet);
        } else {
          internalWallets = mapInternalWallet(internalWallets);
        }
        dispatch(
          setInternalWallet({
            internalWallets,
            refreshChecksum,
            loyaltyPointsInfo,
            otpValidationRequired,
            backendInternalWalletFlag
          })
        );
        const { cart = {} } = setNormalizedCartResponse({
          response,
          request,
          callback,
          dispatch,
          isRecursivelyCalling
        });
        dispatch(getCartSuccess());
        dispatch(setErrorObject({}));
        const { id, postalCode } = cart.deliveryInfo.deliveryAddress;
        if (id && postalCode) {
          dispatch(setCheckedAddress(id, postalCode));
        }
        dispatch(hideLoader('cart-loader'));
        Promise.resolve(cart);
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        if (statusCode === 504) {
          // since only 400 errors are visible to user && only timeout error needs to be conveyed here
          statusCode = 400;
        }
        return errorParser(error, statusCode).then((errorObj = {}) => {
          const { reason = '' } = errorObj;
          /**
                    * If Cookie has older cart id for the authenicated user and the cart is already used once through for placing order
                        by other device for placing, then current stored cart in cookie in isinvalid. So we need to reset the cookie
                        and get all cart for the user.
                    */
          if (statusCode === 401 && !isRecursivelyCalling) {
            return tokenReCreateParser(statusCode, errorObj, requestObj.request)
              .then(() => {
                return Promise.resolve(getCart(requestObj, callback, true)(dispatch));
              })
              .catch(err => {
                return Promise.reject(err);
              });
          }
          if (
            user.toLowerCase().trim() !== 'anonymous' &&
            reason === 'notFound' &&
            !isRecursivelyCalling
          ) {
            delete request.cookies.C;
            let recursive = true;
            if(requestObj?.isFromPDP){
              recursive = false;
            }
            return Promise.resolve(getCart(requestObj, callback, recursive)(dispatch));
          }
          dispatch(getCartFail());
          dispatch(setErrorObject(errorObj));
          dispatch(hideLoader('cart-loader'));
          return Promise.reject(errorObj);
        });
      });
  };
}

const mergeInteranlWallet = (oldWallets, newWallets, selectedWallet) => {
  const isMulitpleWallet = newWallets.length > 1;
  const filterInvalidWallet = _filter(newWallets, wallet => {
    if (isMulitpleWallet) {
      return wallet.multipleWalletEnabledAmount !== 0;
    }
    return wallet.amount !== 0;
  });
  const selectedCodes = filterInvalidWallet.map(wallet => wallet.code);
  const updatedWallets = [];
  for (const wallet of oldWallets) {
    let newObj = {};
    newObj = { ...wallet, isSelected: false };
    for (const filterWallet of filterInvalidWallet) {
      if (filterWallet.code === 'AJIO_CASH_WALLET') {
        const { subWallets } =
          _find(oldWallets, oldWallet => oldWallet.code === filterWallet.code) || {};
        for (let i = 0; i < filterWallet.subWallets.length; i++) {
          const { code } = filterWallet.subWallets[i];
          const oldSubWallet = _find(subWallets, wallet => wallet.code === code) || {};
          filterWallet.subWallets[i] = { ...oldSubWallet, ...filterWallet.subWallets[i] };
        }
      }
      if (filterWallet.code === wallet.code) {
        newObj = { ...wallet, ...filterWallet, isSelected: true };
        break;
      }
    }
    updatedWallets.push(newObj);
  }
  return updatedWallets;
};

export function mergeCart(mergeCartObj) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = `/api/cart/merge`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify({ mergeCartObj }),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        setNormalizedCartResponse({ response, dispatch, filterGiftItem: true });
        dispatch(getCartSuccess());
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        if (statusCode === 504) {
          // since only 400 errors are visible to user && only timeout error needs to be conveyed here
          statusCode = 400;
        }
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(getCartFail());
          dispatch(setErrorObject(errorObj));
          dispatch(hideLoader('cart-loader'));
        });
      });
  };
}

export function checkDeliveryable(pincode, callback) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));

    const apiEndPoint = `/api/cart/delivery/${pincode}`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        callback(response);
        dispatch(hideLoader('cart-loader'));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              checkDeliveryable(pincode, callback)(dispatch);
            })
            .catch(() => {
              dispatch(setErrorObject(errorObj));
              dispatch(hideLoader('cart-loader'));
            });
        });
      });
  };
}

export function updateQuantity(updateEntryObj, updateCallback) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));

    const apiEndPoint = `/api/cart/update`;

    const { entryNumber = -1, newQty: newQuantity = -1, code = '', size = '', panFlagEnabled = false } = updateEntryObj;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify({
          entryNumber,
          newQuantity,
          productCode: code,
          newSize: size
        }),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          code = '',
          guid = '',
          refreshChecksum = '',
          loyaltyPointsInfo = '',
          otpValidationRequired = true,
          backendInternalWalletFlag = false
        } = response;
        let { internalWallets = [] } = response;
        internalWallets = mapInternalWallet(internalWallets);
        let cart = {};
        dispatch(
          setInternalWallet({
            internalWallets,
            refreshChecksum,
            loyaltyPointsInfo,
            otpValidationRequired,
            backendInternalWalletFlag
          })
        );
        const userName = getUserName();
        if (userName.toLowerCase().trim() === 'anonymous') {
          cart.type = 'anonymous';
          cart.id = guid;
        } else {
          cart.type = 'authenicated';
          cart.id = code;
        }
        cart = setCartData(cart, response) || {};
        const cartItem = setCartItem(response, true) || [];
        const giftItem = setGiftItem(response) || [];

        if (response.hasOwnProperty('limitedStock')) {
          cart = {
            ...cart,
            limitedStock: {
              products: [response.limitedStock],
              cardToShow: true
            }
          };
        }

        const messageBar = {
          errorType: 'info',
          message: 'Bag has been updated'
        };
        if(panFlagEnabled) {
          const { reason = '', errorMessage = '' } = cart.cartValueLimitNew || {};
          if (reason === 'MAX_CART_VALUE_LIMIT') {
            messageBar.message = errorMessage;
          }
        } else {
          const { reason = '', errorMessage = '' } = cart.cartValueLimit || {};
          if (reason === 'MAX_CART_VALUE_LIMIT') {
            messageBar.message = errorMessage;
          }
        }
        dispatch(cartItemData(cartItem));
        dispatch(setCart(cart));
        dispatch(giftItemData(giftItem));
        dispatch(getCartSuccess());
        dispatch(setGSTCartDetails(cart?.gstDetails || {}));
        dispatch(getVouchers());
        updateCallback ? updateCallback() : undefined;
        dispatch(hideLoader('cart-loader'));
        dispatch(setErrorObject(messageBar));
        const timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
        return Promise.resolve();
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              return updateQuantity(updateEntryObj)(dispatch);
            })
            .catch(error => {
              dispatch(setErrorObject(error));
              dispatch(hideLoader('cart-loader'));
              const timeout = setTimeout(() => {
                dispatch(setErrorObject({}));
                clearTimeout(timeout);
              }, 5000);
              return Promise.reject(error);
            });
        });
      });
  };
}

export function deleteBulkItemsFromCart(entryNumbers, isRecursivelyCalling = false) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = `/api/cart/bulkdelete`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ entryNumbers })
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401 && !isRecursivelyCalling) {
            return tokenReCreateParser(statusCode, errorObj)
              .then(() => {
                return deleteBulkItemsFromCart(entryNumbers, true)(dispatch);
              })
              .catch(() => {
                dispatch(setErrorObject(errorObj));
                dispatch(hideLoader('cart-loader'));
                return Promise.reject(errorObj);
              });
          }
          dispatch(hideLoader('cart-loader'));

          return Promise.reject(errorObj);
        });
      });
  };
}

export function deleteCard(
  deleteProductObj,
  deleteCallBack,
  isRecursivelyCalling = false,
  callback
) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));

    const { entryNumber = -1, showMessage = true, refreshCartItem = true } = deleteProductObj;

    const apiEndPoint = `/api/cart/delete`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ entryNumber })
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          code = '',
          guid = '',
          refreshChecksum = '',
          loyaltyPointsInfo = '',
          otpValidationRequired = true,
          backendInternalWalletFlag = false
        } = response;
        let { internalWallets = [] } = response;
        internalWallets = mapInternalWallet(internalWallets);
        let cart = {};
        dispatch(
          setInternalWallet({
            internalWallets,
            refreshChecksum,
            loyaltyPointsInfo,
            otpValidationRequired,
            backendInternalWalletFlag
          })
        );
        const userName = getUserName();

        if (userName.toLowerCase().trim() === 'anonymous') {
          cart.type = 'anonymous';
          cart.id = guid;
        } else {
          cart.type = 'authenicated';
          cart.id = code;
        }
        cart = setCartData(cart, response) || {};
        const cartItem = setCartItem(response, true) || [];
        setNormalizedCartResponse({ response, dispatch, filterGiftItem: true });
        if (response.hasOwnProperty('limitedStock')) {
          cart = {
            ...cart,
            limitedStock: {
              products: [response.limitedStock],
              cardToShow: true
            }
          };
        }

        const messageBar = {
          errorType: 'info',
          message: 'Removed from bag'
        };
        if (refreshCartItem) dispatch(cartItemData(cartItem));
        dispatch(setCart(cart));
        dispatch(getCartSuccess());
        dispatch(setGSTCartDetails(cart?.gstDetails || {}));
        dispatch(getVouchers());
        deleteCallBack ? deleteCallBack() : undefined;
        dispatch(hideLoader('cart-loader'));
        if (showMessage) {
          dispatch(setErrorObject(messageBar));
          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
        }
        if (callback) callback();
        return Promise.resolve(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode).then((errorObj = {}) => {
          const { reason = '' } = errorObj;
          if (statusCode === 401 && !isRecursivelyCalling) {
            return tokenReCreateParser(statusCode, errorObj)
              .then(() => {
                return deleteCard(deleteProductObj, deleteCallBack, true)(dispatch);
              })
              .catch(() => {
                dispatch(setErrorObject(errorObj));
                dispatch(hideLoader('cart-loader'));
                return Promise.reject(errorObj);
              });
          }
          errorObj.message = 'OOPS! Unable to remove the product from bag, please try again';
          dispatch(hideLoader('cart-loader'));
          if (showMessage) dispatch(showErrorMessageInfo(errorObj));

          return Promise.reject(errorObj);
        });
      });
  };
}

export function removeCardFromView(key) {
  return dispatch => {
    dispatch(removeCard(key, false));
    if (!isNode()) {
      sessionStorage.removeItem('OOSItems');
    }
    dispatch(setOOSItemInCart([]));
  };
}

export function selectProductSize(size) {
  return dispatch => {
    dispatch(getProductSize(size));
  };
}

export function getCartStock() {
  return (dispatch, getState) => {
    dispatch(showLoader('cart-loader'));
    const {
      flags: { isMergeCheckStockInFetchCart = 'OFF' } = {},
      cartItem = [],
      cart: { stockStatus = {} }
    } = getState();
    let backendFlagEnabled = false;
    for (const iterator of cartItem) {
      if (!iterator?.availableQuantity) {
        backendFlagEnabled = false;
        break;
      }
      backendFlagEnabled = true;
    }
    if (isMergeCheckStockInFetchCart === 'ON' && backendFlagEnabled) {
      const cartStockResponse = cartItem.map(entry => ({
        availableQuantity: entry?.availableQuantity,
        isReturnable: entry?.isReturnable,
        productCode: entry?.code
      }));
      dispatch(
        setCartInventoryCheck({
          productDetails: cartStockResponse,
          status: stockStatus
        })
      );
      dispatch(hideLoader('cart-loader'));
    } else {
      const apiEndPoint = '/api/cart/checkCartStock';

      return fetcher(
        apiEndPoint,
        fetchGetJSONReqOpts({
          method: 'GET',
          headers: { 'content-type': 'application/json' },
          credentials: 'include'
        })
      )
        .then(fetchGetJSONResHandler)
        .then(response => {
          dispatch(hideLoader('cart-loader'));
          dispatch(setCartInventoryCheck(response));
        })
        .catch(error => {
          const statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            dispatch(setErrorObject(errorObj));
            dispatch(hideLoader('cart-loader'));
          });
        });
    }
  };
}

export function fetchInternalWallet(requestObj = {}) {
  const { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  return dispatch => {
    let apiEndPoint;
    const client_type = _get(requestObj, 'request.device.client_type', 'web');
    let body = {};
    const { _fpuuid } = request.cookies;
    if (isRequestOrginIsBrowser) {
      dispatch(showLoader('cart-loader'));
      apiEndPoint = '/api/cart/fetchInternalWallet';
    } else {
      const { headers: { host = '' } = {} } = request;
      apiEndPoint = `http://${host}/api/cart/fetchInternalWallet`;
      body = {
        A: request.cookies.A,
        U: request.cookies.U,
        C: request.cookies.C,
        client_type,
        _fpuuid
      };
    }

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          refreshChecksum = '',
          loyaltyPointsInfo = '',
          otpValidationRequired = true,
          backendInternalWalletFlag = false
        } = response;
        let { internalWallets = [] } = response;
        internalWallets = mapInternalWallet(internalWallets);
        dispatch(
          setInternalWallet({
            internalWallets,
            refreshChecksum,
            loyaltyPointsInfo,
            otpValidationRequired,
            backendInternalWalletFlag
          })
        );
        dispatch(hideLoader('cart-loader'));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
          dispatch(hideLoader('cart-loader'));
        });
      });
  };
}

export function redeemInternalWallet(bodyData = {}, cb) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = '/api/cart/redeemInternalWallet';

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(bodyData)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('cart-loader'));
        if (cb) cb(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

export function getSizeDetail(code, isRecursivelyCalling = false) {
  return dispatch => {
    const apiEndPoint = `/api/cart/sizeVariants/${code}`;
    dispatch(setSizeDetails());
    dispatch(showLoader('Fetch-size'));
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('Fetch-size'));
        dispatch(setSizeDetails(response));
        dispatch(showWishlistDialog());
        return Promise.resolve(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode)
          .then((errorObj = {}) => {
            if (statusCode === 401 && !isRecursivelyCalling) {
              return tokenReCreateParser(statusCode, errorObj)
                .then(() => {
                  return Promise.resolve(getSizeDetail(code, true)(dispatch));
                })
                .catch(err => {
                  dispatch(hideLoader('Fetch-size'));
                  dispatch(setSizeDetails());
                  return Promise.reject(err);
                });
            }
            return Promise.reject(errorObj);
          })
          .catch(err => {
            dispatch(hideLoader('Fetch-size'));
            dispatch(setSizeDetails());
            return Promise.reject(err);
          });
      });
  };
}

export function proceedShipping(cb) {
  return dispatch => {
    const user = readCookie('U');
    if (user === 'anonymous') {
      cb('/login?referrer=/cart');
    } else {
      cb('/shipping');
    }
  };
}
export function setNormalizedCartResponse({
  response = {},
  request = {},
  callback,
  dispatch,
  isRecursivelyCalling,
  filterGiftItem = false
}) {
  const { code = '', guid = '' } = response;
  const { cookies: { C = '' } = {} } = request;
  let cart = {};
  const userName = getUserName(request);

  if (userName.toLowerCase().trim() === 'anonymous') {
    cart.type = 'anonymous';
    cart.id = guid;
  } else {
    cart.type = 'authenicated';
    cart.id = code;
  }
  console.log("REQUEST URL", request.baseUrl)
  const isFromCart = request.baseUrl === '/cart'
  cart = setCartData(cart, response) || {};
  const cartItem = setCartItem(response, isFromCart || filterGiftItem) || [];
  const giftItem = setGiftItem(response) || [];

  if (userName != 'anonymous' && C != code && callback) {
    callback({
      updateCookie: true,
      newCookie: {
        cartId: code,
        guid
      }
    });
  } else if (isRecursivelyCalling) {
    callback({
      updateAuthToken: true,
      newCookie: {
        newAuthToken: request.cookies.A,
        newAuthExpiry: request.expires_in
      }
    });
  }
  if (response.hasOwnProperty('restoredProducts')) {
    const restoredProducts = cartItem.reduce((accumlator, item) => {
      if (item.isRestored) {
        accumlator.push(item.isRestored);
      }
      return accumlator;
    }, []);
    cart = {
      ...cart,
      restoredProducts: {
        products: restoredProducts,
        cardToShow: true
      }
    };
  }
  if (response.hasOwnProperty('rvpReturnFee')) {
    // this is for the retrun fee processing
    cart = { ...cart, rvpReturnFee: response.rvpReturnFee };
  }
  
  if (dispatch) {
    dispatch(cartItemData(cartItem || {}));
    dispatch(giftItemData(giftItem))
    dispatch(setCart(cart || {}));
    dispatch(setGSTCartDetails(cart?.gstDetails || {}));
  }
  return {
    cart,
    cartItem, 
    giftItem
  };
}

export function setOOSItemInCart(OOSItems = []) {
  return {
    type: 'SET_PRODUCT_OUT_OF_STOCK_IN_CART',
    OOSItems,
    cardToShow: OOSItems.length > 0
  };
}

export function setCartPaymentError(errorCode) {
  return {
    type: 'SET_CART_ERROR_CODE',
    errorCode
  };
}

export function setCartPaymentOOSError(oosItemList) {
  return {
    type: 'SET_CART_ERROR_OOS_PAYMENT',
    oosItemList
  };
}

export function setCartDeepLinkingOOSError(deepLinkingOosItemList) {
  return {
    type: 'SET_CART_ERROR_OOS_DEEPLINKING',
    deepLinkingOosItemList
  };
}

export function setCartDealExpireError(dealError = {}) {
  return {
    type: 'SET_CART_ERROR_DEAL_EXPIRE',
    dealError
  };
}

export function reloadPageifSelectedProductIsOOS() {
  return (dispatch, getState) => {
    const {
      cart: {
        size,
        sizeDetails: { baseOptions = [] }
      }
    } = getState();
    let sizeVariantOptions = [];
    baseOptions.forEach((variant, i) => {
      if (variant.variantType === 'FnlSizeVariant') {
        sizeVariantOptions = variant.options;
      }
    });

    if (sizeVariantOptions.find(({ code }) => code == size).stock.stockLevel === 0) {
      window.location.reload();
    }
  };
}

export function deleteBulkOosItems(
  deleteProductObj,
  callback,
  isRecursivelyCalling = false
) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));

    const apiEndPoint = `/api/cart/bulkOosdelete`;
    const {skus = [], guid = '', isFromWishList = false, showMessage = true, refreshCartItem = true} = deleteProductObj
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ skus, guid })
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          code = '',
          guid = '',
          refreshChecksum = '',
          loyaltyPointsInfo = '',
          otpValidationRequired = true,
          backendInternalWalletFlag = false
        } = response;
        let { internalWallets = [] } = response;
        internalWallets = mapInternalWallet(internalWallets);
        let cart = {};
        dispatch(
          setInternalWallet({
            internalWallets,
            refreshChecksum,
            loyaltyPointsInfo,
            otpValidationRequired,
            backendInternalWalletFlag
          })
        );
        const userName = getUserName();

        if (userName.toLowerCase().trim() === 'anonymous') {
          cart.type = 'anonymous';
          cart.id = guid;
        } else {
          cart.type = 'authenicated';
          cart.id = code;
        }
        cart = setCartData(cart, response) || {};
        const cartItem = setCartItem(response) || [];

        if (response.hasOwnProperty('limitedStock')) {
          cart = {
            ...cart,
            limitedStock: {
              products: [response.limitedStock],
              cardToShow: true
            }
          };
        }
        const wishlistMsg = `${skus.length} ${skus.length === 1 ? 'item' : 'items'} added to wishlist`;
        const deleteMsg = `${skus.length} ${skus.length === 1 ? 'item' : 'items'} removed from bag`
        const messageBar = {
          errorType: 'info',
          message: isFromWishList ? wishlistMsg : deleteMsg
        };
        if (refreshCartItem) dispatch(cartItemData(cartItem));
        dispatch(setCart(cart));
        dispatch(getCartSuccess());
        dispatch(getVouchers());
        callback ? callback() : undefined;
        dispatch(hideLoader('cart-loader'));
        if (showMessage) {
          dispatch(setErrorObject(messageBar));
          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
        }
        return Promise.resolve(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode).then((errorObj = {}) => {
          const { reason = '' } = errorObj;
          if (statusCode === 401 && !isRecursivelyCalling) {
            return tokenReCreateParser(statusCode, errorObj)
              .then(() => {
                return deleteBulkOosItems(deleteProductObj)(dispatch);
              })
              .catch(() => {
                const messageBar = {
                  errorType: 'info',
                  message: 'Oops something went wrong! Please try again'
                };
                dispatch(setErrorObject(messageBar));
                dispatch(hideLoader('cart-loader'));
                return Promise.reject(errorObj);
              });
          }
          errorObj.message = 'Oops something went wrong! Please try again';
          dispatch(hideLoader('cart-loader'));
          if (showMessage) dispatch(showErrorMessageInfo(errorObj));

          return Promise.reject(errorObj);
        });
      });
  };
}

function mapInternalWallet(internalWallets) {
  return internalWallets.map(wallet =>
    wallet.code === 'AJIO_CASH_WALLET' && wallet.multipleWalletEnabledAmount <= 0
      ? { ...wallet, isSelected: false }
      : wallet
  );
}

export function addScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export function updatePANCardInfo(panInfoOb = {}, cb) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const { forge } = window;
    if (!forge) {
      addForgeScriptAndProceed(panInfoOb, cb, dispatch);
    } else {
      proceedWithUpdate(panInfoOb, cb, dispatch);
    }
  };
}

function addForgeScriptAndProceed(panInfoOb, cb, dispatch) {
  addScript('https://unpkg.com/node-forge@0.7.0/dist/forge.min.js')
    .then(() => {
      proceedWithUpdate(panInfoOb, cb, dispatch);
    })
    .catch(error => {
      console.error('Error loading script:', error);
      dispatch(hideLoader('cart-loader'));
    });
}

function proceedWithUpdate(panInfoOb, cb, dispatch) {
  let encrypted64;
  const { encryptionKey, version } = panInfoOb;
  let apiObj;
  try {
    if (encryptionKey && window.forge) {
      apiObj = {
        name: getEncryptedData(encryptionKey, panInfoOb.name, version),
        taxPayerId: getEncryptedData(encryptionKey, panInfoOb.panNumber, version),
        dateOfBirth: getEncryptedData(encryptionKey, panInfoOb.dob, version),
        acceptedTnC: panInfoOb.consent
      };
    } else {
      apiObj = {
        name: '',
        taxPayerId: '',
        dateOfBirth: '',
        acceptedTnC: false
      };
    }
    const apiEndPoint = `/api/cart/updatePanCard`;
    fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify({ apiObj }),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(response => fetchGetJSONResHandler(response))
      .then(responseData => {
        if (cb) {
          cb(responseData);
        }
        dispatch(hideLoader('cart-loader'));
      })
      .catch(error => {
        console.log('error', error);
        dispatch(hideLoader('cart-loader'));
        let statusCode = getErrorStatusCode(error);
        if (statusCode === 504) {
          statusCode = 400;
        }
        errorParser(error, statusCode).then(errorObj => {
          if (cb) {
            cb(errorObj);
          }
        });
      });
  } catch (error) {
    console.log('error here', error);
    const errToClient = {
      error: 'Could not encrypt data',
      errorMessage: {
        message: 'Something went wrong'
      }
    };
    dispatch(hideLoader('cart-loader'));
    cb(errToClient);
  }
}

export function changeAddressSelectionOnCart(payload) {
  const { pincode='', addressId='', skipFetchCart=false, enableRushDelivery=false , lat='', long=''} = payload;

  let reqBody = {
    addressId,
    pincode,
    lat,
    long,
    enableRushDelivery
  };

  return dispatch => {
    dispatch(showLoader('cart-loader'));
      const apiEndPoint = '/api/cart/changeAddressSelectionOnCart';
      return fetcher(
        apiEndPoint,
        fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ reqBody }),
      })
    )
    .then(fetchGetJSONResHandler)
    .then(response => {
      if(skipFetchCart) {
        dispatch(hideLoader('cart-loader'));
        return;
      }

      dispatch(getCart({ isRequestOrginIsBrowser: true })).then(resp => {
        dispatch(hideLoader('cart-loader'));
      }).catch(error => {
        dispatch(setErrorObject('Something Went Wrong'));
        dispatch(hideLoader('cart-loader'));
      });
    })
    .catch(error => {
        const statusCode = getErrorStatusCode(error);
        dispatch(hideLoader('cart-loader'));
        return errorParser(error, statusCode)
      .then((errorObj = {}) => {
        return Promise.reject(errorObj);
      })
      .catch(err => {
        return Promise.reject(err);
      });
    });
  };
};

export function applyPriorityDelivery(payload) {
  const { applyPriorityDeliveryList } = payload;
  const reqBody = { applyPriorityDeliveryList };
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = '/api/cart/applyPriorityDelivery';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(reqBody)
      })
    ).then(fetchGetJSONResHandler).then(response => {
      dispatch(getCart({ isRequestOrginIsBrowser: true })).then(r => {
        dispatch(hideLoader('cart-loader'));
      }).catch(error => {
        dispatch(setErrorObject('Something Went Wrong'));
        dispatch(hideLoader('cart-loader'));
      });
     
      return response;
    }).catch(error => {
      dispatch(setErrorObject('Something Went Wrong'));
      dispatch(hideLoader('cart-loader'));
    })
  };
}

export function applyDeliveryType(payload) {
  const { applyDeliveryList } = payload;
  const reqBody = { applyDeliveryTypeList: applyDeliveryList };
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = '/api/cart/applyDeliveryType';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(reqBody)
      })
    ).then(fetchGetJSONResHandler).then(response => {
      dispatch(getCart({ isRequestOrginIsBrowser: true })).then(r => {
        dispatch(hideLoader('cart-loader'));
      }).catch(error => {
        dispatch(setErrorObject('Something Went Wrong'));
        dispatch(hideLoader('cart-loader'));
      });

      return response;
    }).catch(error => {
      dispatch(setErrorObject('Something Went Wrong'));
      dispatch(hideLoader('cart-loader'));
    })
  };
}

export function getCrossSellRecommendations(payload = {}) {
  const {
    visitorId = '',
    cartItems = [],
    tabs = '',
    productsPerTab = 10,
    channelType = 'MSITE',
    userId,
    userClusterId,
    segmentIds,
    displayRatings
  } = payload;

  const reqBody = {
    eventType: 'add-to-cart',
    visitorId,
    cartItems,
    tabs,
    productsPerTab
  };

  return (dispatch, getState) => {
    const state = getState();
    const store = state?.metaData?.name;
    const enableUniversalCohortFlow = getAmplitudeVariantPayload(
      'enableUniversalCohortFlow',
      state,
      false
    );
    const cohortValue = readCohortValueCookie(
      'userCohortValues',
      store,
      'cart',
      enableUniversalCohortFlow
    );
    const normalizedCohortValue = Array.isArray(cohortValue)
      ? cohortValue.join(',')
      : (cohortValue || '').replace(/\|/g, ',');
    const resolvedUserClusterId = userClusterId || normalizedCohortValue;

    const queryParams = new URLSearchParams({ channelType });
    if (userId) queryParams.set('userId', userId);
    if (resolvedUserClusterId) queryParams.set('userClusterId', resolvedUserClusterId);
    if (segmentIds) queryParams.set('segmentIds', segmentIds);
    if (displayRatings !== undefined) queryParams.set('displayRatings', displayRatings);

    const apiEndPoint = `/api/cart/crossSell/recommendations?${queryParams.toString()}`;

    dispatch({ type: CROSS_SELL_RECOMMENDATIONS_REQUEST });
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(reqBody)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch({ type: CROSS_SELL_RECOMMENDATIONS_SUCCESS, payload: response });
        return response;
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch({ type: CROSS_SELL_RECOMMENDATIONS_FAILURE, payload: errorObj });
          return Promise.reject(errorObj);
        });
      });
  };
}
